import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  dialog: {
    maxHeight: '80vh',
    minWidth: 320,
    maxWidth: 640,
    whiteSpace: 'pre-wrap',
  },
  container: {
    padding: 16,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },

  icon: {
    marginInline: '1em',
  },

  textStyle: {
    textAlign: 'justify',
    textJustify: 'inter-word',
  },

  shortMessage: {
    extend: 'textStyle',
    fontWeight: 'bold',
  },

  longMessage: {
    extend: 'textStyle',
    marginTop: 16,
  },
});
